// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_2WBsdfcITW","togglePanel":"_11IV_xTDQc","toggleButton":"_2a191KaRlo","separator":"_2amtlySmAa"};